import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-order-exception",
  "use": "icon-order-exception-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-order-exception\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 56.889c-250.311 0-455.111 204.8-455.111 455.111S261.689 967.111 512 967.111 967.111 762.311 967.111 512 762.311 56.889 512 56.889m0 853.333c-221.867 0-398.222-176.355-398.222-398.222S290.133 113.778 512 113.778 910.222 290.133 910.222 512 733.867 910.222 512 910.222\" p-id=\"2950\" /><path d=\"M512 682.667c-17.067 0-28.444 5.689-39.822 17.066-11.378 11.378-17.067 22.756-17.067 39.823 0 17.066 5.689 28.444 17.067 39.822 11.378 11.378 22.755 17.066 39.822 17.066 17.067 0 28.444-5.688 39.822-17.066C563.2 768 568.89 756.622 568.89 739.556c0-17.067-5.689-28.445-17.067-39.823-11.378-11.377-22.755-17.066-39.822-17.066z m-51.2-455.111l17.067 409.6h62.577l22.756-409.6H460.8z\" p-id=\"2951\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/order-exception.svg
// module id = Keap
// module chunks = 20